import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./lib/auth-context";
import App from "./App";
import { ErrorBoundary, AppCrashFallback } from "./components/ErrorBoundary";
import { maybeAutoReloadOnChunkError } from "./lib/chunk-reload";

// Suppress Monaco's language-worker requests — we only edit Python.
self.MonacoEnvironment = {
  getWorker: () => new Worker(URL.createObjectURL(new Blob([""], { type: "text/javascript" })))
};

import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<AppCrashFallback />} onError={(error) => maybeAutoReloadOnChunkError(error)}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
